var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircularCheckboxChecked22Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.2C16.6334 21.2 21.2 16.6334 21.2 11C21.2 5.36674 16.6334 0.800049 11 0.800049C5.36674 0.800049 0.800049 5.36674 0.800049 11C0.800049 16.6334 5.36674 21.2 11 21.2Z",
    stroke: "#0061ED",
    strokeWidth: 1.36
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 17.1199C14.3799 17.1199 17.1199 14.3799 17.1199 10.9999C17.1199 7.6199 14.3799 4.87988 10.9999 4.87988C7.6199 4.87988 4.87988 7.6199 4.87988 10.9999C4.87988 14.3799 7.6199 17.1199 10.9999 17.1199Z",
    fill: "#0061ED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularCheckboxChecked22Px);
export default ForwardRef;